import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {
	Table,
	Button,
	Modal,
	message,
	Icon,
	Divider,
	Form,
	Input,
	Checkbox,
	TimePicker,
	InputNumber,
	DatePicker
} from 'antd';
import {
	fetchAttendanceList,
	updateAttendanceSchedule
} from '../../actions/attendance-actions';
import attendanceScheduleService from '../../services/Attendance/attendance-schedule-service';


class AttendanceSchedule extends React.Component {

	componentWillMount() {
		this.props.fetchAttendanceList();
	}

	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
	}

	componentDidMount() {
		console.log(this.props);
	}

	attendanceColumn = [
		// {title: "班次", 				key: "sequence", dataIndex: "sequence", className: 'table-global-head-tiny'},
		{ title: "上班时间", key: "on_time", dataIndex: "on_time", className: 'table-global-head-short' },
		{ title: "下班时间", key: "off_time", dataIndex: "off_time", className: 'table-global-head-short' },
		{ title: "上班提前签到", key: "forward_time", dataIndex: "forward_time", className: 'table-global-head' },
		{ title: "下班推迟签到", key: "backward_time", dataIndex: "backward_time", className: 'table-global-head' },
		{
			title: "有无午休", key: "has_noon_check", dataIndex: "has_noon_check", className: 'table-global-head-short', render: (text, record) =>
				<Checkbox disabled checked={record.has_noon_check}></Checkbox>
		},
		{ title: "午休开始时间", key: "noon_start_time", dataIndex: "noon_start_time", className: 'table-global-head', render: (text, record) => record.has_noon_check ? text : "--" },
		{ title: "午休结束时间", key: "noon_end_time", dataIndex: "noon_end_time", className: 'table-global-head', render: (text, record) => record.has_noon_check ? text : "--" },
		{
			title: "操作", key: "action", dataIndex: "action", className: 'table-global-head', render: (text, record, index) => this.props.access.attendanceSchedule.u_value &&
				<Button icon="edit" size="small" className="row-action-btn" onClick={this.updateCurrent.bind(this, index)}>编辑</Button>
		}
	]

	state = {
		currentModalStatus: false
	}

	closeCurrentModal = () => {
		this.setState({ currentModalStatus: false });
	}

	submitCurrentModal = () => {
		// submit
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let posts = {
					...values,
					on_time: values.on_time.format('HH:mm'),
					off_time: values.off_time.format('HH:mm')
				};
				if (values.noon_start_time) {
					posts.noon_start_time = values.noon_start_time.format('HH:mm');
				}
				if (values.noon_end_time) {
					posts.noon_end_time = values.noon_end_time.format('HH:mm');
				}
				if (null !== this.state.currentIndex) {
					posts.id = this.state.currentData.id;
					this.props.updateAttendanceSchedule(posts, this.state.currentIndex, status => {
						if (status) {
							message.success("修改考勤班次成功", 4);
						} else {
							message.error("修改考勤班次失败", 4);
						}
					});
				} else {
					attendanceScheduleService.addAttendanceSchedule(posts, res => {
						this.props.fetchAttendanceList();
						if (res.data.Success) {
							message.success("添加考勤班次成功", 4);
						} else {
							message.error("添加考勤班次失败", 4);
						}
					}, err => { });
				}
				this.closeCurrentModal();
			}
		})
	}

	insertCurrent = () => {

		this.setState({ currentModalStatus: true });
		// insert
		this.setState({
			currentData: {
				sequence: null,
				on_time: "09:00",
				off_time: "17:00",
				forward_time: null,
				backward_time: null,
				has_noon_check: false,
				noon_start_time: "12:00",
				noon_end_time: "13:00",
				remark: null,
			},
			noonCheckControl: false,
		});
		this.setState({ currentIndex: null });
	}

	setOnTime = value => {
		if (value) {
			this.setState({ filter: { ...this.state.filter, on_time: value.format('HH:mm') } });
			this.props.fetchAttendanceList({ ...this.state.filter,page:1 });
		}else{
			this.props.fetchAttendanceList();
		}
	}

	setOffTime = value => {
		if (value) {
			this.setState({ filter: { ...this.state.filter, off_time: value.format('HH:mm') } });
			this.props.fetchAttendanceList({ ...this.state.filter,page:1 });
		}else{
			this.props.fetchAttendanceList( );
		}
	}
	updateCurrent = index => {
		this.setState({ currentModalStatus: true });
		// update
		this.setState({
			currentData: this.props.attendance.attendanceData[index],
			noonCheckControl: this.props.attendance.attendanceData[index].has_noon_check,
		});
		this.setState({ currentIndex: index });
	}

	multiDelete = () => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择需要删除的数据', 4);
			return;
		}
		attendanceScheduleService.multiDelete({ ids: this.state.selectedIDs }, res => {
			if (res.data.Success) {
				message.success('删除成功', 4);
			} else {
				message.error(res.data.Errors[0]);
			}
			this.props.fetchAttendanceList();
		}, res => message.error("删除失败", 4));
	}

	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({ selectedIDs: ids });
		}
	}

	fetchPageAttendanceList = pagination => {
		console.log(pagination);
		this.props.fetchAttendanceList({...this.state.filter, page: pagination.current });
	}

	setNoonCheck = event => this.setState({
		noonCheckControl: event.target.checked
	})

	render() {
		return (
			<div className="app-module-item">
				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title="考勤班次"
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					onOk={this.submitCurrentModal}>
					<div style={{ textAlign: "center" }}>
						{this.state.currentData &&
							<Form onSubmit={this.submitCurrentModal} className="login-form" layout="inline">
								<div style={{ visibility: 'hidden' }}>
									<Form.Item label="考勤班次" className='AttendanceSchedule' >
										{this.props.form.getFieldDecorator('sequence', {
											initialValue: this.state.currentData.sequence
										})(<InputNumber placeholder={1} style={{ width: "300px" }} />)}
									</Form.Item>
								</div>
								<div style={{ marginLeft: "-7px" }}>
									<Form.Item label="上班时间" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('on_time', {
											rules: [{ required: true, message: '请输入上班时间' }],
											initialValue: moment(this.state.currentData.on_time, 'HH:mm')
										})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "300px" }} defaultOpenValue={moment(this.state.currentData.on_time, 'HH:mm:ss')} />)}
									</Form.Item>
								</div>
								<div style={{ marginLeft: "-7px" }}>
									<Form.Item label="下班时间" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('off_time', {
											rules: [{ required: true, message: '请输入下班时间' }],
											initialValue: moment(this.state.currentData.off_time, 'HH:mm')
										})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "300px" }} defaultOpenValue={moment(this.state.currentData.off_time, 'HH:mm:ss')} />)}
									</Form.Item>
								</div>
								<div>
									<Form.Item label="上班提前签到时间" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('forward_time', {
											rules: [{ required: true, message: '请输入上班提前签到时间' }],
											initialValue: this.state.currentData.forward_time
										})(<InputNumber style={{ width: "300px" }} />)}
									</Form.Item>
								</div>
								<div>
									<Form.Item label="下班推迟签到时间" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('backward_time', {
											rules: [{ required: true, message: '请输入下班推迟签到时间' }],
											initialValue: this.state.currentData.backward_time
										})(<InputNumber style={{ width: "300px" }} />)}
									</Form.Item>
								</div>
								<div>
									<Form.Item label="有无午休" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('has_noon_check', {
											rules: [{ required: true, message: '请输入下班推迟签到时间' }],
											initialValue: this.state.currentData.has_noon_check
										})(<Checkbox onClick={this.setNoonCheck} defaultChecked={this.state.currentData.has_noon_check} />)}
									</Form.Item>
								</div>
								{this.state.noonCheckControl && <div>
									<Form.Item label="午休开始时间" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('noon_start_time', {
											rules: [],
											initialValue: moment(this.state.currentData.noon_start_time, 'HH:mm')
										})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "300px" }} />)}
									</Form.Item>
								</div>}
								{this.state.noonCheckControl && <div>
									<Form.Item label="午休结束时间" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('noon_end_time', {
											rules: [],
											initialValue: moment(this.state.currentData.noon_end_time, 'HH:mm')
										})(<TimePicker minuteStep={30} format="HH:mm" style={{ width: "300px" }} />)}
									</Form.Item>
								</div>}
								<div>
									<Form.Item label="备注" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('remark', {
											initialValue: this.state.currentData.remark
										})(<Input.TextArea style={{ width: "300px" }} />)}
									</Form.Item>
								</div>
							</Form>}
					</div>
				</Modal>
				<div className="colAction">
					{this.props.access.attendanceSchedule.c_value && <Button type="primary" onClick={this.insertCurrent}>
						<Icon type="plus-circle-o" />
						<span>新增</span>
					</Button>}
					<Divider type="vertical" />
					{this.props.access.attendanceSchedule.d_value && <Button type="primary" onClick={this.multiDelete}>
						<Icon type="delete" />
						<span>批量删除</span>
					</Button>}
					<Divider type="vertical" />
					<span style={{ marginRight: "5px" }}>上班时间 : </span>
					<TimePicker minuteStep={30} format="HH:mm" style={{ width: "162px" }} onChange={this.setOnTime.bind(this)} />
					<Divider type="vertical" />
					<span style={{ marginRight: "5px" }}>下班时间 : </span>
					<TimePicker minuteStep={30} format="HH:mm" style={{ width: "162px" }} onChange={this.setOffTime} />
				</div>
				<Table columns={this.attendanceColumn} dataSource={this.props.attendance.attendanceData}
					pagination={{
						total: this.props.attendance.attendanceTotalPage,
						defaultCurrent: 1,
						pageSize: this.props.attendance.attendancePageSize,
						current: this.props.attendance.attendancePage
					}}
					scroll={{ x: 600 }}
					onChange={this.fetchPageAttendanceList.bind(this)}
					rowKey={record => record.id} rowSelection={this.rowSelection} />
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		attendance: state.attendance
	}
}

const mapDispatchToProps = {
	fetchAttendanceList,
	updateAttendanceSchedule
}

AttendanceSchedule = Form.create()(AttendanceSchedule);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AttendanceSchedule));


// WEBPACK FOOTER //
// ./src/routes/Attendance/AttendanceSchedule.js